/* eslint-disable react/prop-types */
import React from 'react';

import { useSlug } from '../hooks/useSlug';
import {
  dateStringIsValid,
  elapsedMins,
  RelativeDate,
  RelativeDateProps,
} from '../RelativeDate';
import { classes } from '../utils';

import styles from './styles.module.css';

export type RecentTimestampProps = RelativeDateProps & {
  relatedTimestamp?: boolean;
  urgencyEnabled?: boolean;
  urgencyCutoffMins?: number;
  showDateAfterCutoff?: boolean;
};

// forwardRef strangely has reversed generic signature from parameters
export const RecentTimestamp = React.forwardRef<
  HTMLDivElement,
  RecentTimestampProps
>(function Base(props, ref) {
  const {
    urgencyEnabled = false,
    urgencyCutoffMins = 30,
    relatedTimestamp = false,
    name = 'recent-timestamp',
    ...rest
  } = props;

  const slug = useSlug(name);

  const isUrgent = React.useMemo(() => {
    if (!urgencyEnabled) {
      return false;
    }

    if (rest.updatedAt && dateStringIsValid(rest.updatedAt)) {
      return elapsedMins(new Date(rest.updatedAt)) < urgencyCutoffMins;
    }

    if (rest.publishedAt && dateStringIsValid(rest.publishedAt)) {
      const result =
        elapsedMins(new Date(rest.publishedAt)) < urgencyCutoffMins;

      return result;
    }

    return true;
  }, [rest, urgencyEnabled]);

  const cx = classes(
    [
      styles.wrapper,
      {
        [styles.urgent]: isUrgent,
        urgent: isUrgent,
      },
    ],
    props
  );

  return (
    <div
      ref={ref}
      className={cx}
      data-component={relatedTimestamp ? 'related-timestamp' : slug}
    >
      <RelativeDate {...rest} />
    </div>
  );
});
